import { useEffect, useState, useCallback, useMemo } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import ReactDiffViewer from "react-diff-viewer-continued";
import { editorProjectServices } from "../../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const CompareFileVersionHistory = ({ Show, Hide, Title, ids, version }) => {
  const [leftCode, setLeftCode] = useState("");
  const [rightCode, setRightCode] = useState("");
  const [leftVersion, setLeftVersion] = useState("1");
  const [rightVersion, setRightVersion] = useState("1");
  const [copiedSide, setCopiedSide] = useState(null);
  const { studyId } = useParams()

  const versions = useMemo(
    () => Array.from({ length: version || 0 }, (_, i) => i + 1),
    [version]
  );

  const fetchCodeByVersion = useCallback(
    async (version, setter) => {
      if (!ids?.projectId || !ids?.uniqueId || !version) return;
      try {
        const { data } =
          await editorProjectServices.getProjectDetailsByVersion(
            studyId,
            ids.projectId,
            ids.uniqueId,
            version
          );
        setter(data?.code ?? "");
      } catch (err) {
        console.error("Error fetching version details:", err);
        setter("");
      }
    },
    [ids?.projectId, ids?.uniqueId]
  );

  useEffect(() => {
    fetchCodeByVersion(leftVersion, setLeftCode);
  }, [leftVersion, fetchCodeByVersion]);

  useEffect(() => {
    fetchCodeByVersion(rightVersion, setRightCode);
  }, [rightVersion, fetchCodeByVersion]);

  const handleCopy = async (content, side) => {
    try {
      await navigator.clipboard.writeText(content);
      setCopiedSide(side);
      setTimeout(() => setCopiedSide(null), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const diffStyles = {
    diffContainer: {
      fontSize: "13px",
    },
  };

  return (
    <Offcanvas show={Show} onHide={Hide} style={{ width: "80%" }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0 overflow-hidden">
        <div
          className="justify-content-between toolbar border-bottom hstack w-100 py-1 px-2"
          style={{ height: 35 }}
        >
          {/* Left Side */}
          <div className="hstack gap-2">
            <span>Select Version:</span>
            <Form.Select
              size="sm"
              style={{ width: 120 }}
              value={leftVersion}
              onChange={(e) => setLeftVersion(e.target.value)}
            >
              {versions.map((ver) => (
                <option key={ver} value={ver}>
                  {`v${ver}.0`}
                </option>
              ))}
            </Form.Select>
            <span
              role="button"
              className="d-flex align-items-center gap-1"
              onClick={() => handleCopy(leftCode, "left")}
            >
              <i className="fa-solid fa-copy" />
              {copiedSide === "left" ? "Copied!" : "Copy"}
            </span>
          </div>

          {/* Right Side */}
          <div className="hstack gap-2">
            <span>Select Version:</span>
            <Form.Select
              size="sm"
              style={{ width: 120 }}
              value={rightVersion}
              onChange={(e) => setRightVersion(e.target.value)}
            >
              {versions.map((ver) => (
                <option key={ver} value={ver}>
                  {`v${ver}.0`}
                </option>
              ))}
            </Form.Select>
            <span
              role="button"
              className="d-flex align-items-center gap-1"
              onClick={() => handleCopy(rightCode, "right")}
            >
              <i className="fa-solid fa-copy" />
              {copiedSide === "right" ? "Copied!" : "Copy"}
            </span>
          </div>
        </div>

        <div style={{ height: "calc(100vh - 79px)", overflow: "auto" }}>
          <ReactDiffViewer
            oldValue={leftCode}
            newValue={rightCode}
            splitView={true}
            showDiffOnly={false}
            styles={diffStyles}
          />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CompareFileVersionHistory;
